import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getDocumentSeries,
  getParticularPage,
  getNext,
  getPrevious,
  createDocumentSeries,
  updateDocumentSeries,
  handleSearch,
  getDocumentSeriesById,
} from "./thunk";

const initialState = {
  documentSeriesLists: [],
  edit: false,
  documentSeries: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingDocumentSeries: false,
  loadingNext: false,
  showCreateModal: false,
};

export const documentSeriesSlice = createSlice({
  name: "documentSeries",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllDocumentSeries: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingDocumentSeries = false;
      state.documentSeries = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createDocumentSeries.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createDocumentSeries.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createDocumentSeries.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(getDocumentSeriesById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDocumentSeriesById.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = true;
      state.documentSeries = action.payload.data;
    });
    builder.addCase(getDocumentSeriesById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
      state.documentSeries = null;
    });
    builder.addCase(updateDocumentSeries.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateDocumentSeries.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateDocumentSeries.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getDocumentSeries.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingDocumentSeries = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDocumentSeries.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingDocumentSeries = false;
        state.documentSeriesLists = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDocumentSeries.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingDocumentSeries = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllDocumentSeries } = documentSeriesSlice.actions;

export default documentSeriesSlice.reducer;
